<script setup lang="ts">
import { UserDao } from '@/dao';
import { useUserStoreRef } from '@/stores';
import { onMounted, ref } from 'vue';
import { i18nextPromise } from '../../locize/i18n';
import { LoadingComp, SplashComp } from '@/components';
import { useTaskLoader } from '@/composeables/loaders';
import { useGridSettings } from '@/composeables/grid/gridSettings';

const doneLoading = ref(false);
const langLoaded = ref(false);

const { AddLoader, LoadState } = useTaskLoader();
const { user } = useUserStoreRef();

// Start loading i18n language file
AddLoader(
    async () => {
        await i18nextPromise;
        langLoaded.value = true;
    },
    'splash.languages',
    'fa-scroll',
);

// Start loading the user
AddLoader(
    async () => {
        // TODO: Move this to userStore
        user.value = await UserDao.User();

        if (user.value) {
            await useGridSettings().LoadSettings(user.value.ID);
        }
    },
    'splash.user',
    'fa-user',
);

// emits
const emits = defineEmits(['loaded']);

// once we display this we wait for all the loaders to finish and set that we are loaded
onMounted(async () => {
    await Promise.all(LoadState.value.NeedsLoading.map((x) => x.prom));
    doneLoading.value = true;
    emits('loaded', doneLoading.value);
});
</script>

<template>
    <SplashComp :time-before-content-visible="1000">
        <img
            class="mb-4"
            src="@/assets/img/EQWhite.png"
            alt=""
        />
        <LoadingComp :state="LoadState"> </LoadingComp>
    </SplashComp>
</template>
